// Quiz Short type-pair specs for the live-preview controller — a THIN CONSUMER
// of the generated typography catalog (B11 — typography de-mirror).
//
// The font pairs are authored ONCE in the shared TS source
// remotion-service/templates/src/shared/typography/quiz_short_pairs.ts and
// emitted to the checked-in JSON below by generate-typography-catalog.mjs;
// quiz_short_live_preview_controller.js spreads these into its
// `static TYPE_PAIR_SPECS`, and the Ruby leg
// (ShortsWizard::Shared::QuizShortTypePairs::SPECS) consumes the same JSON — so
// the preview can never drift from the renderer's authored pairs.
import catalog from "../../../remotion-service/templates/generated/typography/quiz_short.json"
import { toJsSpecs } from "./typography_catalog"

export const QUIZ_SHORT_TYPE_PAIRS = toJsSpecs(catalog, { profile: "bare" })
